import { Link, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SEO from './components/SEO';
import { getOrganizationSchema, getTestimonialSchema, getWebSiteSchema, getBreadcrumbSchema } from './components/CompetitionSchema';
import GoogleDriveVideo from './components/GoogleDriveVideo';

const testimonials = [
  {
    name: 'Muhammad Umar',
    school: 'LGS',
    text: 'PMMC proved to be a very mentally stimulating activity and provided us an opportunity to see the practical applications of math. Such an opportunity at our grade level is rare.',
    img: '/muhammadumar.png',
  },
  {
    name: 'Muhammad Shayan Akbar',
    school: 'International School Lahore',
    text: 'Participating in the Pakistan Mathematical Modeling Challenge was a great experience. I learned a lot and gained valuable information through the process. It is one of the best platforms to test and expand one\'s knowledge in math modeling. Thank you for organizing such an enriching competition.',
    img: '/shayaan.png',
  },
  {
    name: 'Ibrahim Kashif',
    school: 'LGS JT',
    text: 'This competition was brought up to me by my friend, and not really knowring what it was, I participated. As I delved deeper into the competition, I saw how they had woven delicate intricacies into the complex question. It was great fun, collectively thinking and deciphering the problem statement.',
    img: '/ibrahim kashif.png',
  },
  {
    name: 'Muhammad Ali',
    school: 'Lahore Grammar School',
    text: 'The competition was really a challenging one. It brought out our competitive selves and taught us about the importance of team-work',
    img: '/muhammadali.png',
  },
  {
    name: 'Muhammad Umar Danish',
    school: 'City School',
    text: 'No less than one of the most entertaining yet tedious weeks of my life attempting this challenge.',
    img: '/Umar Danish.png',
  },
];

const affiliations = [
  '/igeologo.png',
  '/wmtcaffiliatelogo.png',
  '/immclogo.png',
  '/comaplogo.png',
  '/neounionlogo.png',
];

const flashcards = [
  { year: '2023', team: 'Math', img: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Science', img: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Literature', img: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80' },
  { year: '2023', team: 'Informatics', img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Math', img: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Science', img: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Literature', img: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80' },
  { year: '2022', team: 'Informatics', img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
];

const blogs = [
  {
    title: 'The Pakistan Mathematical Modeling Challenge',
    summary: 'The Pakistan Mathematical Modeling Challenge (PMMC) is more than just a math competition. It\'s an innovative platform that challenges students to apply mathematical theories to solve complex, real-world problems. Unlike traditional math contests that focus on equations and problem-solving from textbooks, the PMMC requires participants to use their analytical and creative thinking to model and predict solutions for pressing issues, such as climate change, urban planning, or even the spread of diseases.',
  },
  {
    title: 'The Pakistan Geography Olympiad',
    summary: 'PGO is more than a competition; it\'s a journey of geographic discovery for high school and pre-university students nationwide. Through dynamic challenges and real-world scenarios, participants delve into the diverse landscapes, cultures, and phenomena shaping our world. Join us as we nurture critical thinking, foster collaboration, and inspire a new generation of informed global citizens.',
  },
  {
    title: 'PMMC Top 10',
    summary: 'Congratulations to the top 10 teams of the Pakistan Mathematical Modeling Challenge! Stay tuned for the selection of the top 2 teams on April 29. The teams are listed in no specific order.',
  },
];

const winners = [
  '/WhatsApp Image 2024-09-27 at 8.03.42 AM.png',
  '/WhatsApp Image 2024-09-27 at 8.03.41 AM.png',
  '/WhatsApp Image 2024-09-27 at 8.03.40 AM.png',
  '/group.png',
  '/team picture.png',
  '/WhatsApp Image 2024-09-27 at 8.03.43 AM.png',
  '/WhatsApp Image 2024-09-27 at 8.03.39 AM.png',
  '/WhatsApp Image 2024-09-27 at 8.03.39 AM (2).png',
];

const competitionCards = [
  {
    name: 'Pakistan Mathematical Modeling Challenge (PMMC)',
    path: '/competitions/pmmc',
    img: '/pmmclogo.png',
    desc: "A Gateway to Mathematical Excellence. The PMMC is a national competition focused on mathematical modeling skills, discovering and nurturing Pakistan's brightest young talents."
  },
  {
    name: 'World Mathematics Team Championship (WMTC)',
    path: '/competitions/wmtc',
    img: '/wmtclogo.png',
    desc: 'An international team-based mathematics competition, WMTC brings together top students from around the world to compete in advanced mathematics and teamwork.'
  },
  {
    name: 'Pakistan Geography Olympiad (PGEO)',
    path: '/competitions/pgo',
    img: '/pgeologo.png',
    desc: 'A national geography competition that challenges students to explore and understand the world around them through geographical knowledge and critical thinking.'
  }
];

// Participating Schools sample data
const participatingSchools = [
  'Aitchison College',
  'Beaconhouse',
  'Froebel\'s International School',
  'Government Boys Degree College',
  'International School Lahore',
  'Karachi Grammar School',
  'LACAS',
  'Lahore Grammar School',
  'Lahore Grammar School For Boys (LGS-JT)',
  'Nixor College',
  'Roots Millennium School',
  'The City School'
];

const gallery = [
  '/Aitchison_College_pak_team-removebg-preview.png',
  '/LGS_pak_team-removebg-preview.png',
  '/isl_team_pic-removebg-preview.png',
  '/unnamed-removebg-preview.png',
];

export default function Home() {
  const [navOpen, setNavOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [rotatingImageIndex, setRotatingImageIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const heroVariant = parseInt(searchParams.get('hero') || '1');
  
  const heroImages = ['/37.png', '/36.png'];
  const rotatingImages = ['/IMG_8240 2.png', '/unnamed.jpg'];
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 3000); // Change image every 3 seconds
    
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotatingImageIndex((prevIndex) => (prevIndex + 1) % rotatingImages.length);
    }, 4000); // Change rotating image every 4 seconds
    
    return () => clearInterval(interval);
  }, []);

  // Enhanced SEO Data
  const seoData = {
    title: "Capstone Pakistan",
    description: "Capstone Pakistan leads Pakistan's academic excellence through PMMC, WMTC, and PGEO competitions. Join 500+ students from 50+ schools in international mathematical modeling and geography olympiads. Register now for Pakistan's premier academic competitions.",
    keywords: "Pakistan Mathematical Modeling Challenge, PMMC, World Mathematics Team Championship, WMTC, Pakistan Geography Olympiad, PGEO, academic competitions Pakistan, mathematical modeling, international competitions, student excellence, IMMC, Pakistan math team, geography olympiad Pakistan, mathematical modeling challenge registration, IMMC Pakistan team results, academic excellence Pakistan, student competitions, mathematical modeling challenge",
    url: "https://capstonepakistan.org",
    type: "website",
    image: "https://capstonepakistan.org/capstone-logo-large.svg",
    author: "Capstone Pakistan",
    section: "Academic Competitions",
    tags: ["PMMC", "WMTC", "PGEO", "Academic Competitions", "Pakistan", "Mathematical Modeling", "Geography Olympiad", "Student Excellence"],
    structuredData: [
      getWebSiteSchema(),
      getOrganizationSchema(),
      getBreadcrumbSchema([
        { name: "Home", url: "https://capstonepakistan.org/" }
      ]),
      ...testimonials.map(testimonial => getTestimonialSchema([testimonial]))
    ]
  };

  return (
    <>
      <SEO {...seoData} />
      <div className="min-h-screen bg-white text-gray-900 flex flex-col -mt-px">
        {/* Hero Section - Multiple Variants */}
        {heroVariant === 1 && (
          <section className="relative py-8 lg:py-32 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
            <div className="max-w-7xl mx-auto px-6">
              {/* Mobile Layout */}
              <div className="lg:hidden">
                {/* Text above image on mobile */}
                <div className="text-center mb-8">
                  <h1 className="text-3xl font-bold text-white mb-6 leading-tight">
                    Empowering Pakistan's
                    <span className="text-white/95 block text-2xl">Academic Excellence</span>
                  </h1>
                </div>
                
                {/* Image */}
                <div className="relative mb-8">
                  <div className="relative w-full h-[400px] overflow-hidden rounded-[20px] shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 bg-white">
                    <div className="relative w-full h-full overflow-hidden rounded-[18px] m-0.5">
                      {heroImages.map((image, index) => (
                        <img 
                          key={index}
                          src={image} 
                          alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                          className={`absolute inset-0 w-full h-full object-cover rounded-xl transition-opacity duration-1000 ease-in-out ${
                            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                          }`}
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ))}
                      {/* Overlay with team info */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-xl">
                        <div className="absolute bottom-6 left-6 right-6">
                          <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                              <span className="text-white text-lg">🇵🇰</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Buttons below image on mobile */}
                <div className="text-center">
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
              </div>
              
              {/* Desktop Layout */}
              <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center">
                {/* Left side - Content */}
                <div className="text-center lg:text-left">
                  <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
                    Empowering Pakistan's
                    <span className="text-white/95 block">Academic Excellence</span>
                  </h1>

                  <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
                
                {/* Right side - Image */}
                <div className="relative">
                  <div className="relative w-full h-[500px] overflow-hidden rounded-[20px] shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 bg-white">
                    <div className="relative w-full h-full overflow-hidden rounded-[18px] m-0.5">
                      {heroImages.map((image, index) => (
                        <img 
                          key={index}
                          src={image} 
                          alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                          className={`absolute inset-0 w-full h-full object-cover rounded-xl transition-opacity duration-1000 ease-in-out ${
                            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                          }`}
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ))}
                      {/* Overlay with team info */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent rounded-xl">
                        <div className="absolute bottom-6 left-6 right-6">
                          <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                              <span className="text-white text-lg">🇵🇰</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Hero Variant 2 - Full-width image with overlay text */}
        {heroVariant === 2 && (
          <section className="relative py-0 lg:py-0 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
            <div className="lg:hidden">
              {/* Mobile Layout - Full height hero */}
              <div className="relative h-screen flex items-center justify-center">
                {/* Background Image */}
                <div className="absolute inset-0">
                  {heroImages.map((image, index) => (
                    <img 
                      key={index}
                      src={image} 
                      alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                        index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                      }`}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ))}
                  {/* Dark overlay */}
                  <div className="absolute inset-0 bg-black/50"></div>
                </div>
                
                {/* Content overlay */}
                <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
                  <div className="mb-8">
                    <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
                      <span className="text-white text-3xl">🇵🇰</span>
                    </div>
                  </div>
                  
                  <h1 className="text-5xl font-bold text-white mb-6 leading-tight">
                    Empowering Pakistan's
                    <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent block">Academic Excellence</span>
                  </h1>
                  
                  <p className="text-xl text-white/90 mb-8 leading-relaxed">
                    Join 500+ students from 50+ schools in Pakistan's premier academic competitions
                  </p>
                  
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Desktop Layout */}
            <div className="hidden lg:block">
              <div className="relative h-screen flex items-center">
                <div className="absolute inset-0">
                  {heroImages.map((image, index) => (
                    <img 
                      key={index}
                      src={image} 
                      alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                        index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                      }`}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ))}
                  <div className="absolute inset-0 bg-black/40"></div>
                </div>
                
                <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
                  <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="text-white">
                      <div className="mb-8">
                        <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-6">
                          <span className="text-white text-4xl">🇵🇰</span>
                        </div>
                      </div>
                      
                      <h1 className="text-6xl font-bold mb-6 leading-tight">
                        Empowering Pakistan's
                        <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent block">Academic Excellence</span>
                      </h1>
                      
                      <p className="text-2xl text-white/90 mb-8 leading-relaxed">
                        Join 500+ students from 50+ schools in Pakistan's premier academic competitions
                      </p>
                      
                      <div className="flex flex-col sm:flex-row gap-4">
                        <a 
                          href="#our-assessments" 
                          className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                        >
                          Explore Programs
                        </a>
                        <Link 
                          to="/about" 
                          className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                        >
                          Learn About Us
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Hero Variant 3 - Card-based layout */}
        {heroVariant === 3 && (
          <section className="relative py-8 lg:py-32 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
            <div className="max-w-7xl mx-auto px-6">
              <div className="lg:hidden">
                {/* Mobile Layout - Card style */}
                <div className="text-center mb-8">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-white text-2xl">🏆</span>
                  </div>
                  <h1 className="text-4xl font-bold text-white mb-4 leading-tight">
                    Pakistan's Premier
                    <span className="text-white/95 block">Academic Platform</span>
                  </h1>
                  <p className="text-lg text-white/90 mb-6">
                    Empowering students to compete globally
                  </p>
                </div>
                
                {/* Image Card */}
                <div className="relative mb-8">
                  <div className="bg-white/10 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-white/20">
                    <div className="relative h-[300px]">
                      {heroImages.map((image, index) => (
                        <img 
                          key={index}
                          src={image} 
                          alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                          }`}
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ))}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-sm">🇵🇰</span>
                          </div>
                          <div className="text-white">
                            <div className="font-semibold">Pakistan Team</div>
                            <div className="text-sm opacity-90">International Champions</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-6">
                      <div className="grid grid-cols-3 gap-4 mb-6">
                        <div className="text-center">
                          <div className="text-2xl font-bold text-white">500+</div>
                          <div className="text-sm text-white/80">Students</div>
                        </div>
                        <div className="text-center">
                          <div className="text-2xl font-bold text-white">50+</div>
                          <div className="text-sm text-white/80">Schools</div>
                        </div>
                        <div className="text-center">
                          <div className="text-2xl font-bold text-white">3</div>
                          <div className="text-sm text-white/80">Competitions</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Buttons */}
                <div className="text-center">
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
              </div>
              
              {/* Desktop Layout */}
              <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center">
                <div className="text-center lg:text-left">
                  <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mb-6">
                    <span className="text-white text-3xl">🏆</span>
                  </div>
                  <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
                    Pakistan's Premier
                    <span className="text-white/95 block">Academic Platform</span>
                  </h1>
                  <p className="text-xl text-white/90 mb-8">
                    Empowering students to compete globally and represent Pakistan on the world stage
                  </p>
                  
                  <div className="grid grid-cols-3 gap-6 mb-8">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-white">500+</div>
                      <div className="text-sm text-white/80">Students</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-white">50+</div>
                      <div className="text-sm text-white/80">Schools</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-white">3</div>
                      <div className="text-sm text-white/80">Competitions</div>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
                
                <div className="relative">
                  <div className="bg-white/10 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-white/20">
                    <div className="relative h-[400px]">
                      {heroImages.map((image, index) => (
                        <img 
                          key={index}
                          src={image} 
                          alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                          }`}
                          loading="lazy"
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ))}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      <div className="absolute bottom-6 left-6 right-6">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-lg">🇵🇰</span>
                          </div>
                          <div className="text-white">
                            <div className="font-semibold text-lg">Pakistan Team</div>
                            <div className="text-sm opacity-90">International Champions</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Hero Variant 4 - Minimalist with stats */}
        {heroVariant === 4 && (
          <section className="relative py-8 lg:py-32 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
            <div className="max-w-7xl mx-auto px-6">
              <div className="lg:hidden">
                {/* Mobile Layout - Minimalist */}
                <div className="text-center mb-8">
                  <h1 className="text-4xl font-bold text-white mb-4 leading-tight">
                    Capstone Pakistan
                  </h1>
                  <p className="text-xl text-white/90 mb-6">
                    Leading academic excellence through international competitions
                  </p>
                  
                  {/* Stats */}
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="bg-white/20 rounded-xl p-4 border border-white/30">
                      <div className="text-2xl font-bold text-white">500+</div>
                      <div className="text-sm text-white/80">Students</div>
                    </div>
                    <div className="bg-white/20 rounded-xl p-4 border border-white/30">
                      <div className="text-2xl font-bold text-white">50+</div>
                      <div className="text-sm text-white/80">Schools</div>
                    </div>
                  </div>
                </div>
                
                {/* Image */}
                <div className="relative mb-8">
                  <div className="relative w-full h-[350px] overflow-hidden rounded-2xl shadow-lg">
                    {heroImages.map((image, index) => (
                      <img 
                        key={index}
                        src={image} 
                        alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                          index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                        }`}
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ))}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  </div>
                </div>
                
                {/* Buttons */}
                <div className="text-center">
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
              </div>
              
              {/* Desktop Layout */}
              <div className="hidden lg:grid lg:grid-cols-2 gap-12 items-center">
                <div className="text-center lg:text-left">
                  <h1 className="text-6xl font-bold text-white mb-6 leading-tight">
                    Capstone Pakistan
                  </h1>
                  <p className="text-2xl text-white/90 mb-8">
                    Leading academic excellence through international competitions
                  </p>
                  
                  {/* Stats */}
                  <div className="grid grid-cols-3 gap-6 mb-8">
                    <div className="bg-white/20 rounded-xl p-6 border border-white/30">
                      <div className="text-3xl font-bold text-white">500+</div>
                      <div className="text-sm text-white/80">Students</div>
                    </div>
                    <div className="bg-white/20 rounded-xl p-6 border border-white/30">
                      <div className="text-3xl font-bold text-white">50+</div>
                      <div className="text-sm text-white/80">Schools</div>
                    </div>
                    <div className="bg-white/20 rounded-xl p-6 border border-white/30">
                      <div className="text-3xl font-bold text-white">3</div>
                      <div className="text-sm text-white/80">Competitions</div>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                    <a 
                      href="#our-assessments" 
                      className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Explore Programs
                    </a>
                    <Link 
                      to="/about" 
                      className="inline-block px-8 py-4 bg-transparent hover:bg-white/10 text-white font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-white shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                      Learn About Us
                    </Link>
                  </div>
                </div>
                
                <div className="relative">
                  <div className="relative w-full h-[500px] overflow-hidden rounded-2xl shadow-lg">
                    {heroImages.map((image, index) => (
                      <img 
                        key={index}
                        src={image} 
                        alt={`Pakistan Mathematics Team representing at International Mathematical Modeling Challenge ${index + 1}`} 
                        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${
                          index === currentImageIndex ? 'opacity-100' : 'opacity-0'
                        }`}
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    ))}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Moving Stripe */}
        <div className="w-full bg-white py-3 lg:py-2 overflow-hidden relative">
          <div className="whitespace-nowrap animate-marquee-slow text-xl font-bold tracking-wide text-black flex items-center">
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
            <span className="mx-8 flex items-center">
              <span className="mr-2">🇵🇰</span>
              Represent Pakistan on the World Stage
            </span>
          </div>
        </div>

        {/* Testimonials Section - Horizontal Marquee Animation */}
        <section className="py-12 lg:py-20 bg-gradient-to-r from-blue-50 to-blue-100">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Student Testimonials
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Hear from our participants
              </p>
            </div>
          </div>
          
          <div className="overflow-hidden relative">
            <div className="flex animate-marquee-horizontal-slow">
              {/* First set of testimonials */}
              {testimonials.map((testimonial, i) => (
                <div
                  key={i}
                  className="flex-shrink-0 w-80 lg:w-96 mx-3 lg:mx-4 bg-white rounded-[20px] p-6 lg:p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400"
                >
                  <div className="flex items-center gap-4 mb-4">
                    <img
                      src={testimonial.img}
                      alt={testimonial.name}
                      className="w-14 h-14 rounded-full object-cover border-2 border-teal-100 shadow-sm flex-shrink-0"
                    />
                    <div>
                      <span className="inline-block px-2.5 py-1 rounded-md bg-gray-800 text-white text-xs font-bold uppercase tracking-wide mb-2">
                        {testimonial.school}
                      </span>
                      <h3 className="text-xl font-bold text-black leading-tight">
                        {testimonial.name}
                      </h3>
                    </div>
                  </div>
                  <p className="text-gray-800 text-base leading-relaxed">
                    "{testimonial.text}"
                  </p>
                </div>
              ))}
                
                {/* Duplicate set for seamless loop */}
                {testimonials.map((testimonial, i) => (
                  <div
                    key={`duplicate-${i}`}
                    className="flex-shrink-0 w-80 lg:w-96 mx-3 lg:mx-4 bg-white rounded-[20px] p-6 lg:p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400"
                  >
                    <div className="flex items-center gap-4 mb-4">
                      <img
                        src={testimonial.img}
                        alt={testimonial.name}
                        className="w-14 h-14 rounded-full object-cover border-2 border-teal-100 shadow-sm flex-shrink-0"
                      />
                      <div>
                        <span className="inline-block px-2.5 py-1 rounded-md bg-gray-800 text-white text-xs font-bold uppercase tracking-wide mb-2">
                          {testimonial.school}
                        </span>
                        <h3 className="text-xl font-bold text-black leading-tight">
                          {testimonial.name}
                        </h3>
                      </div>
                    </div>
                    <p className="text-gray-800 text-base leading-relaxed">
                      "{testimonial.text}"
                    </p>
                  </div>
                ))}
              </div>
            </div>
        </section>

        {/* Affiliations Section - Moved to second position */}
        <section className="py-12 lg:py-16 bg-gray-50">
          <h2 className="text-3xl font-bold text-center mb-8 lg:mb-12 text-gray-900">Our Affiliations</h2>
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex justify-center items-center gap-8 lg:gap-12 flex-wrap">
              {affiliations.map((logo, i) => (
                <img 
                  key={i} 
                  src={logo} 
                  alt={`Affiliation Logo ${i + 1} - International Academic Partnership`} 
                  className="h-12 lg:h-16 w-auto grayscale hover:grayscale-0 transition-all duration-300 hover:scale-110" 
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </section>

        {/* Upcoming Events Section - Box Hill Style */}
        <section className="relative py-12 lg:py-20 lg:py-32 overflow-hidden bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
          
          <div className="relative max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Text Content */}
              <div className="text-white">
                <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
                  Upcoming Events
                </h2>
                <p className="text-xl lg:text-2xl mb-8 leading-relaxed">
                  Explore your academic potential at our next competition
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-white rounded-full"></div>
                    <span className="text-lg">Pakistan Mathematical Modeling Challenge</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-white rounded-full"></div>
                    <span className="text-lg">World Mathematics Team Championship</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-white rounded-full"></div>
                    <span className="text-lg">Pakistan Geography Olympiad</span>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a 
                    href="#our-assessments" 
                    className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    View Events
                  </a>
                </div>
              </div>
              
              {/* Right side - Visual Elements */}
              <div className="relative">
                <div className="relative w-full h-[400px] lg:h-[500px] rounded-2xl overflow-hidden">
                  {/* Cityscape silhouette on left */}
                  <div className="absolute left-0 bottom-0 w-1/3 h-full">
                    <div className="absolute bottom-0 left-0 w-full h-32 bg-gray-800 rounded-t-full"></div>
                    <div className="absolute bottom-8 left-4 w-8 h-16 bg-gray-700 rounded"></div>
                    <div className="absolute bottom-8 left-16 w-6 h-20 bg-gray-700 rounded"></div>
                    <div className="absolute bottom-8 left-28 w-10 h-24 bg-gray-700 rounded"></div>
                  </div>
                  
                  {/* Abstract geometric shapes */}
                  <div className="absolute right-0 top-0 w-2/3 h-full">
                    <div className="absolute top-10 right-10 w-32 h-32 bg-red-500 rounded-lg transform rotate-12"></div>
                    <div className="absolute top-32 right-32 w-24 h-24 bg-yellow-400 rounded-full"></div>
                    <div className="absolute top-20 right-60 w-20 h-20 bg-teal-400 transform rotate-45"></div>
                    <div className="absolute top-60 right-20 w-28 h-28 bg-blue-500 rounded-lg"></div>
                  </div>
                  
                  {/* Student silhouette */}
                  <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2">
                    <div className="w-16 h-32 bg-white/20 rounded-full backdrop-blur-sm"></div>
                    <div className="absolute top-8 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-white/30 rounded-full"></div>
                  </div>
                  

                </div>
              </div>
            </div>
          </div>
          

        </section>

        {/* Light Background Section - Latest News */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Latest News
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Stay updated with our latest achievements and announcements
              </p>
            </div>
            <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl lg:text-3xl font-bold mb-6 text-gray-900 leading-tight">
                Pakistan Mathematics Team A and Pakistan Mathematics Team B Win Honorable Mentions at the International Mathematical Modeling Challenge
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                We are thrilled to announce that both Pakistan Mathematics Team A and Pakistan Mathematics Team B have achieved honorable mentions at the prestigious International Mathematical Modeling Challenge. This remarkable achievement showcases the exceptional mathematical talent and dedication of our students, who competed against teams from over 39 countries worldwide.
              </p>
            </div>
          </div>
        </section>

        {/* Our Champions Section - Dynamic Design with Fixed Grid Layout */}
        <section className="relative py-20 lg:py-32 overflow-hidden bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
          <div className="relative max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Our Champions
              </h2>
              <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
                Celebrating the brightest minds who represent Pakistan on the global stage
              </p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
              {winners.slice(0, 8).map((img, i) => (
                <div key={i} className="group relative">
                  <div className="relative overflow-hidden rounded-2xl shadow-2xl transform group-hover:scale-105 transition-all duration-300">
                    <img src={img} alt="Winner" className="w-full h-48 object-cover" />
                  </div>
                </div>
              ))}
            </div>
            
            <div className="text-center">
              <a 
                href="https://drive.google.com/file/d/1uBbLNwUNVGLnw3cfmu1eyTmbPWoviu0i/view?usp=sharing" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-blue-700 font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                View 2024 Student Awards
              </a>
            </div>
          </div>
        </section>

        {/* PMMC Instagram Integration Section */}
        <section className="py-20 bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center mb-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mr-4">
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </div>
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">Follow PMMC on Instagram</h2>
              </div>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Stay connected with the latest updates, behind-the-scenes moments, and student achievements from the Pakistan Mathematical Modeling Challenge
              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Instagram Preview */}
              <div className="relative">
                <div className="bg-white rounded-[20px] p-8 lg:p-10 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                  {/* Instagram Header */}
                  <div className="flex items-center mb-6 pb-4 border-b border-gray-200">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center mr-3">
                      <span className="text-white font-bold text-lg">P</span>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">pmmcofficial</div>
                      <div className="text-sm text-gray-500">Pakistan Mathematical Modeling Challenge</div>
                    </div>
                    <div className="ml-auto">
                      <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </div>
                  </div>

                  {/* Instagram Content */}
                  <div className="space-y-6">
                    {/* Featured Post 1 */}
                    <div className="bg-gradient-to-r from-blue-500 to-blue-700 rounded-2xl p-6 text-white">
                      <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3">
                          <span className="text-white text-sm font-bold">🏆</span>
                        </div>
                        <div>
                          <div className="font-semibold">Championship Highlights</div>
                        </div>
                      </div>
                      <p className="text-sm leading-relaxed">
                        "Celebrating our incredible teams who represented Pakistan at the International Mathematical Modeling Challenge! 🇵🇰 Your dedication and brilliance continue to inspire the next generation of mathematicians."
                      </p>
                    </div>

                    {/* Featured Post 2 */}
                    <div className="bg-gradient-to-r from-green-500 to-teal-600 rounded-2xl p-6 text-white">
                      <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3">
                          <span className="text-white text-sm font-bold">📚</span>
                        </div>
                        <div>
                          <div className="font-semibold">Registration Open</div>
                        </div>
                      </div>
                      <p className="text-sm leading-relaxed">
                        "🚀 PMMC 2024 registration is now LIVE! Join hundreds of students across Pakistan in this prestigious mathematical modeling challenge. Link in bio! #PMMC2024 #MathModeling"
                      </p>
                    </div>

                    {/* Featured Post 3 */}
                    <div className="bg-gradient-to-r from-orange-500 to-red-600 rounded-2xl p-6 text-white">
                      <div className="flex items-center mb-4">
                        <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-3">
                          <span className="text-white text-sm font-bold">🎓</span>
                        </div>
                        <div>
                          <div className="font-semibold">Student Spotlight</div>
                        </div>
                      </div>
                      <p className="text-sm leading-relaxed">
                        "Meet our amazing participants! These brilliant minds are solving real-world problems through mathematical modeling. Your future is bright! ✨ #StudentSpotlight #FutureLeaders"
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right side - Content and CTA */}
              <div className="text-center lg:text-left">
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                  Join Our Instagram Community
                </h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Follow <span className="font-semibold text-blue-600">@pmmcofficial</span> for exclusive content, competition updates, student achievements, and behind-the-scenes moments from the Pakistan Mathematical Modeling Challenge.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
                    <span className="text-lg text-gray-700">Real-time competition updates</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-pink-600 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
                    <span className="text-lg text-gray-700">Student success stories</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-orange-600 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
                    <span className="text-lg text-gray-700">Exclusive behind-the-scenes content</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse" style={{animationDelay: '1.5s'}}></div>
                    <span className="text-lg text-gray-700">Registration reminders and deadlines</span>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a 
                    href="https://www.instagram.com/pmmcofficial/?hl=en" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-8 py-4 bg-black hover:bg-gray-800 text-white font-semibold text-lg rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    Follow @pmmcofficial
                  </a>
                  <a 
                    href="https://pakistanmathteam.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-8 py-4 bg-white hover:bg-gray-50 text-gray-800 font-semibold text-lg rounded-lg transition-colors duration-200 border-2 border-gray-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
                    </svg>
                    Learn About PMMC
                  </a>
                </div>

                {/* Social Stats */}
                <div className="grid grid-cols-1 gap-6 mt-12">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-orange-600">24/7</div>
                    <div className="text-sm text-gray-600">Updates</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Rotating Images Section - Celebrating Our Success */}
        <section className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Celebrating Our Success
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Witness the moments that define our journey towards academic excellence
              </p>
            </div>
            
            <div className="bg-white rounded-[20px] p-8 lg:p-10 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Rotating Image */}
              <div className="relative">
                <div className="relative w-full h-[400px] lg:h-[500px] overflow-hidden rounded-2xl shadow-md">
                  {rotatingImages.map((image, index) => (
                    <img 
                      key={index}
                      src={image} 
                      alt={`Capstone Pakistan Success Story ${index + 1} - Academic Excellence Achievement`} 
                      className={`absolute inset-0 w-full h-full object-cover rounded-2xl transition-all duration-1000 ease-in-out transform ${
                        index === rotatingImageIndex 
                          ? 'opacity-100 scale-100 rotate-0' 
                          : 'opacity-0 scale-110 rotate-3'
                      }`}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  ))}
                  
                  {/* Overlay with success indicators */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl">
                    <div className="absolute bottom-6 left-6 right-6">
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center animate-pulse" style={{animationDelay: '0.5s'}}>
                          <span className="text-white text-xs font-bold">PMMC</span>
                        </div>
                        <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center animate-pulse" style={{animationDelay: '1s'}}>
                          <span className="text-white text-xs font-bold">WMTC</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  

                </div>
              </div>
              
              {/* Right side - Content */}
              <div className="text-center lg:text-left">
                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                  Building Tomorrow's Leaders
                </h3>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Our competitions provide students with unique opportunities to develop critical thinking, 
                  problem-solving skills, and international exposure. Through rigorous challenges and 
                  collaborative learning, we prepare the next generation of innovators and leaders.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse"></div>
                    <span className="text-lg text-gray-700">International Recognition</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-green-600 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
                    <span className="text-lg text-gray-700">Academic Excellence</span>
                  </div>
                  <div className="flex items-center space-x-4">
                    <div className="w-3 h-3 bg-blue-600 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
                    <span className="text-lg text-gray-700">Global Networking</span>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a 
                    href="#our-assessments" 
                    className="inline-block px-8 py-4 bg-black hover:bg-gray-800 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                  >
                    Join Our Programs
                  </a>
                </div>
              </div>
            </div>
            </div>
          </div>
        </section>



        {/* Our Assessments Section - Blue Theme */}
        <section id="our-assessments" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6 leading-tight">
                Our Assessments
              </h2>
              <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
                Discover the prestigious competitions that open doors to international recognition
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-red-500 rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
                <div className="text-center mb-6">
                  <img 
                    src="/pmmclogo.png" 
                    alt="Pakistan Mathematical Modeling Challenge PMMC Logo" 
                    className="w-24 h-24 object-contain rounded-full mx-auto mb-4 border-4 border-white shadow-xl bg-white" 
                    loading="lazy"
                  />
                  <h3 className="text-2xl font-bold text-white mb-2">Pakistan Mathematical Modeling Challenge</h3>
                  <p className="text-white/90">The official national competition for the International Mathematical Modeling Challenge (IMMC)</p>
                </div>
                <div className="text-center">
                  <Link to="/competitions/pmmc" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-red-600 font-semibold rounded-lg transition-colors duration-200">
                    Learn More
                  </Link>
                </div>
              </div>
              <div className="bg-black rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
                <div className="text-center mb-6">
                  <img 
                    src="/wmtclogo.png" 
                    alt="World Mathematics Team Championship WMTC Logo" 
                    className="w-24 h-24 object-contain rounded-full mx-auto mb-4 border-4 border-white shadow-xl bg-white" 
                    loading="lazy"
                  />
                  <h3 className="text-2xl font-bold text-white mb-2">World Mathematics Team Championship</h3>
                  <p className="text-white/90">A team-based international mathematics competition bringing together top students worldwide</p>
                </div>
                <div className="text-center">
                  <Link to="/competitions/wmtc" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-blue-600 font-semibold rounded-lg transition-colors duration-200">
                    Learn More
                  </Link>
                </div>
              </div>
              <div className="bg-green-500 rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
                <div className="text-center mb-6">
                  <img 
                    src="/pgeologo.png" 
                    alt="Pakistan Geography Olympiad PGEO Logo" 
                    className="w-24 h-24 object-contain rounded-full mx-auto mb-4 border-4 border-white shadow-xl bg-black" 
                    loading="lazy"
                  />
                  <h3 className="text-2xl font-bold text-white mb-2">Pakistan Geography Olympiad</h3>
                  <p className="text-white/90">The national qualifying competition for the International Geography Olympiad (iGeo)</p>
                </div>
                <div className="text-center">
                  <Link to="/competitions/pgo" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-green-600 font-semibold rounded-lg transition-colors duration-200"
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Watch WMTC in Action Section */}
        <section className="py-20 bg-gradient-to-r from-red-600 via-orange-600 to-red-800">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                Watch WMTC in Action
              </h2>
              <p className="text-xl text-white/90 leading-relaxed max-w-3xl mx-auto">
                Experience the excitement and international collaboration of the World Mathematics Team Championship
              </p>
            </div>
            
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <div className="aspect-video mb-6 rounded-2xl overflow-hidden shadow-md">
                  <iframe 
                    src="https://www.youtube.com/embed/Kr8dnoYlcII" 
                    title="2023 WMTC Official Movie" 
                    className="w-full h-full"
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">World Mathematics Team Championship</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Experience the excitement and international collaboration of the World Mathematics Team Championship.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Video Section - PMMC Highlights */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                More About PMMC
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Additional highlights and behind-the-scenes footage from the Pakistan Mathematical Modeling Challenge
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <div className="mb-6">
                  <GoogleDriveVideo
                    fileId="1fkqNiIXHligto4vkp6nTChIn4bJrBvBC"
                    title="PMMC Highlights"
                    className="w-full"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">PMMC Highlights</h3>
                <p className="text-gray-600 leading-relaxed">
                  Watch the highlights from the Pakistan Mathematical Modeling Challenge and see our winning team that represented Pakistan on the world stage.
                </p>
              </div>
              
              <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
                <div className="aspect-video mb-6 rounded-2xl overflow-hidden shadow-md bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
                  <div className="text-center text-white">
                    <svg className="w-16 h-16 mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    <h4 className="text-xl font-semibold mb-2">Follow PMMC on Instagram</h4>
                    <p className="text-sm opacity-90">For more exclusive content and updates</p>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Stay Connected</h3>
                <p className="text-gray-600 leading-relaxed">
                  Follow our Instagram page for exclusive behind-the-scenes content, student spotlights, and real-time updates from PMMC.
                </p>
                <div className="mt-4">
                  <a 
                    href="https://www.instagram.com/pmmcofficial/?hl=en" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-black hover:bg-gray-800 text-white font-semibold rounded-lg transition-all duration-200 hover:scale-105"
                  >
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    Follow @pmmcofficial
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Assessment Guides Section - Blue Theme */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-6 leading-tight">
                Assessment Guides
              </h2>
              <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
                Everything you need to know about participating in our competitions
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto justify-items-center">
              <div className="bg-black rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 w-full max-w-md">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">WMTC Guide</h3>
                  <p className="text-white/90">Step-by-step instructions for the Mathematical Modeling Challenge</p>
                </div>
                <div className="text-center">
                  <a href="https://drive.google.com/file/d/1JqJaZojhguvk9mQKhPpjsRMPJsQhhGeB/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-blue-600 font-semibold rounded-lg transition-colors duration-200">
                    View Guide
                  </a>
                </div>
              </div>
              <div className="bg-green-500 rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 w-full max-w-md">
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2">PGEO Guide</h3>
                  <p className="text-white/90">Step-by-step instructions for the Pakistan Geography Olympiad</p>
                </div>
                <div className="text-center">
                  <a href="/pgeo" className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-green-600 font-semibold rounded-lg transition-colors duration-200">
                    View Guide
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Resources Section - Simple CTA */}
        <section className="relative py-20 lg:py-32 overflow-hidden bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700">
          <div className="relative max-w-7xl mx-auto px-6">
            <div className="text-center">
              <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                Resources & Insights
              </h2>
              <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto mb-12">
                Discover valuable resources and insights for academic excellence
              </p>
              
              <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 max-w-2xl mx-auto">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                  </svg>
                </div>
                <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
                  Access Our Complete Resource Library
                </h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  Explore comprehensive guides, competition resources, student testimonials, and academic insights to help you excel in your academic journey.
                </p>
                <Link to="/blogs" className="inline-block px-8 py-4 bg-black hover:bg-gray-800 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                  Explore Resources
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
} 